function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAmexIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 70 70"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m48.9 24.3 1.4-3.7h6.2v-6.7H14.1v42.4h42.4v-6.7h-5.9L48.4 47l-2.2 2.5H29.6V36.2h-5.5L31 20.7h6.7l1.6 3.5v-3.5h8.3zm-4.6 2.5v-1.5l.6 1.5 2.8 7.4h2.6l2.8-7.4.5-1.5v8.8h2.9V22.8h-4.8l-2.2 5.7-.6 1.6-.6-1.6-2.2-5.7h-4.8V34h3zM38.1 34h3.3l-5-11.3h-3.9l-5 11.3h3.3l.9-2.2h5.5zm-4.2-7.4.6-1.4.6 1.4 1.2 2.9h-3.5zm-2 9.6v11.3h9.4V45h-6.6v-2h6.4v-2.4h-6.4v-2h6.6v-2.4zm20 11.1h3.7l-5.3-5.6 5.3-5.6h-3.7l-3.4 3.7-3.4-3.7h-3.8l5.3 5.7-5.3 5.6h3.6l3.4-3.7zm1.4-5.5 3.2 3.3v-6.5z",
  style: {
    fill: "#006fcf"
  }
}));
export default SvgAmexIcon;